import React, { useState, useEffect, useRef } from 'react';
import './OrderConfirmation.scss';
import { ReviewCart } from "./ReviewCart/ReviewCart";
import * as _ from 'lodash';
import { useSelector } from 'react-redux';
import { FxCurrency, AlertService, FxDate, http, general, formatService, useNavigationService, localstorage } from '../fx-core';
import Dialog from '@material-ui/core/Dialog';
import { UserAddress } from "./UserAddress/UserAddress";
import { AddressForm } from "./../MyAccount/AddressForm/AddressForm";
import {DeliveryMode }  from './DeliveryMode/DeliveryMode';
import { PaymentMethod } from './PaymentMethod/PaymentMethod';
import { Coupons } from "./Coupons/Copuons";
import { DeliverySlots } from "./DeliverySlots/DeliverySlots";
import { PickupAddress } from './PickupAddress/PickupAddress';
import { DeliveryAddress } from './DeliveryAddress/DeliveryAddress';
import { DeliveryCharge } from './DeliveryCharge/DeliveryCharge';
import { PreviewOrder } from './PreviewOrder/PreviewOrder';
import { PickUpSlots } from './PickUpSlots/PickUpSlots';

const OrderConfirmation = (props) => {


  //delivery date

// Utility function to calculate min and max delivery dates
// Enhanced utility function
// Enhanced utility function - Find EARLIEST delivery date
const calculateDeliveryDateRange = (cartItems) => {
  if (!cartItems || cartItems.length === 0) {
    const minDate = new Date();
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3);
    return { minDate, maxDate };
  }

  // Calculate earliest possible delivery date based on the item with SHORTEST prep time
  let minDeliveryDays = Infinity; // Start with a very large number
  
  cartItems.forEach(item => {
    const deliveryTime = item.deliveryTime || 0;
    const deliveryUnits = item.deliveryTimeUnits || 1;
    
    let deliveryDays = 0;
    switch (deliveryUnits) {
      case 1: // Minutes
        deliveryDays = deliveryTime / (24 * 60);
        break;
      case 2: // Hours
        deliveryDays = deliveryTime / 24;
        break;
      case 3: // Days
        deliveryDays = deliveryTime;
        break;
      default:
        deliveryDays = deliveryTime;
    }
    
    // Find the SMALLEST delivery time (earliest possible date)
    if (deliveryDays < minDeliveryDays) {
      minDeliveryDays = deliveryDays;
    }
  });

  const minDate = new Date();
  minDate.setDate(minDate.getDate() + Math.ceil(minDeliveryDays));
  
  const maxDate = new Date();
  maxDate.setMonth(maxDate.getMonth() + 3);

  return {
    minDate,
    maxDate
  };
};
  const cartInfo = useSelector<any, any>(store => store.cart);
  const cart = cartInfo;
  console.log("cartInfo", cart);
  
  const [userId, setUserId] = useState(props.userId ? parseInt(props.userId) : 0);
  const [stallId, setStallId] = useState(cart.stallId);
    const [uengageId, setuengageId] = useState(cart.uengageId);

  const [communityId, setCommunityId] = useState(localstorage.getItem('communityId'));
  const[deliveryTime, setDeliveryTime] = useState(cartInfo.deliveryTime);
  const[deliveryTimeUnits, setDeliveryTimeUnits] = useState(cartInfo.deliveryTimeUnits );
  //console.log("deliveryTime, deliveryTimeUnits", deliveryTime, deliveryTimeUnits);

  const allDeliveryModes = [
    { text: 'Delivery', name: 'deliverymode', value: 'Delivery', checked: true },
    { text: 'Pickup', name: 'deliverymode', value: 'Pickup', checked: false }
  ];
  const allPaymentOptions = [
    { text: 'Cash On Delivery', name: 'paymentoption', value: 'cod', checked: false },
    { text: 'Razorpay (UPI, Credit/Debit Card, NetBanking)', name: 'paymentoption', value: 'razorpay', checked: true }
  ];

//console.log("uengageId", uengageId);

  let defaultAddress = {
    fullName: null,
    mobile: '',
    fullAddress: '',
    id: 0
  };

  let defaultStall = {
    address: '',
    id: 0,
    name: '',
    slug: '',
    isDeliveryPartnerEnabled: false
  };
  let defaultPreviewOrderData: any = {};

  const { navigate } = useNavigationService();
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [deliveryModes, setDeliveryModes] = useState([]);
    const [stall, setStall] = useState(defaultStall);

// const [deliveryPartners, setDeliveryPartners] = useState([
//   { text: "Self Delivery", value: "self_delivery", checked: true },
//   { text: "Porter", value: "porter", checked: false }
// ]);

console.log("Setting stall:", stall?.uengageId);
const [deliveryPartners, setDeliveryPartners] = useState(() => {
  const partners = [{ text: "Self Delivery", value: "self_delivery", checked: true }];
  
  // Only add Porter option if uengageId exists
  if (stall?.uengageId && stall?.isDeliveryPartnerEnabled) {
    partners.push({ text: "Porter", value: "porter", checked: false });
  }
  
  return partners;
});

useEffect(() => {
  const partners = [{ text: "Self Delivery", value: "self_delivery", checked: true }];
  
  // Only add Porter option if uengageId exists
  console.log("Updating delivery partners. uengageId:", stall?.uengageId, "stall:", stall?.isDeliveryPartnerEnabled);
  if (stall?.uengageId && stall?.isDeliveryPartnerEnabled) {
    partners.push({ text: "Porter", value: "porter", checked: false });
  }
  
  setDeliveryPartners(partners);
}, [stall?.uengageId, stall]);

const [serviceabilityRequest, setServiceabilityRequest] = useState(null); // For request data
  const [address, setAddress] = useState(defaultAddress);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [couponList, setCouponList] = useState([]);
  const [open, setOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewOrderData, setPreviewOrderData] = useState(defaultPreviewOrderData);
  const [buttonDisable, setButtonDisable] = useState(false);

  // Calculate delivery date range based on cart items
// const deliveryDateRange = calculateDeliveryDateRange(cart.items || []);
const initialDeliveryDateRange = calculateDeliveryDateRange(cart.items || []);

  let defaultContex = {
    deliveryMode: 'Delivery',
    deliveryCharge: 0,
    deliveryChargeMsg: null,
    addressId: 0,
    deliverySlotId: 0,
    selectedDeliveryDate: formatService.getDateStringForServer(initialDeliveryDateRange.minDate), // Use calculated minDate
    minDate: formatService.getDateStringForServer(initialDeliveryDateRange.minDate),
    selectedUserCouponId: 0,
    paymentMode: 'razorpay',
    selectedCouponValue: 0,
    doorDeliveryMsg: "You will be notified once the order is shipped!",
    pickupDeliveryMsg: "You will be notified once the order is ready!",
    selectedCouponId: 0,
    selectedCouponValueTypeId: 2,//2-Value
    minimumOrderAmount: null,
    deliveryPartner: "self_delivery",
    serviceability: null,
    payouts: null
  };

  const [currentContext, setCurrentContext] = useState(defaultContex);

const [minDate, setMinDate] = useState(initialDeliveryDateRange.minDate);
const [maxDate, setMaxDate] = useState(initialDeliveryDateRange.maxDate);
// Prevents a duplicate sync firing immediately after the mount sync
const isFirstRender = useRef(true);
const syncCartToDB = () => {
    // If cart is empty, delete the DB record so other devices
    // don't restore stale items on next open
    if (!cart.items || cart.items.length === 0) {
        const cartId = localstorage.getItem('activeCartId');
        if (cartId) {
            let apiOptions: any = { url: `cart/${cartId}` };
            http.delete(apiOptions).then(() => {
                localstorage.removeItem('activeCartId');
            });
        }
        return;
    }

    // ── Calculate discounted total — same logic as your order flow ──
    const discountedTotal = Math.max(
        0,
        cart.totalAmount - (currentContext.selectedCouponValue || 0)
    );
    const loyaltyPoints = Math.floor(discountedTotal);  // 1 point per ₹1 after discount

    let guestToken = localstorage.getItem('guestCartToken');
      if (!guestToken) {
          guestToken = Math.random().toString(36).substring(2) + Date.now().toString(36);
          localstorage.setItem('guestCartToken', guestToken);
      }

    const inputData = {
        userId:        userId || null,
        guestToken:    userId ? null : guestToken,
        stallId:       stallId,
        totalAmount:   cart.totalAmount,
        source:        'web',
        loyaltyPoints: loyaltyPoints,   // ← based on discounted amount
        items: cart.items.map((item: any) => ({
            productId:   item.id,
            productName: item.itemName,
            imagePath:   item.imagePath,
            quantity:    item.quantity,
            unitPrice:   item.price,
            totalPrice:  item.totalPrice
        }))
    };
    let apiOptions: any = { url: 'cart/sync', data: inputData };
    http.post(apiOptions).then((res: any) => {
        localstorage.setItem('activeCartId', res.data.cartId);
    });
};

const updateCartActivity = _.debounce(() => {
    const cartId = localstorage.getItem('activeCartId');
    if (!cartId) return;
    let apiOptions: any = { url: `cart/${cartId}/activity`, data: {} };
    http.post(apiOptions);
}, 30000);
  
const onInit = () => {
    getStallById();
    getDefaultAddress();
    getAvailableStallTiming();
    getAvailableCoupons();
    syncCartToDB();
  

      // Fetch serviceability for Porter when component loads
  if (currentContext.deliveryMode === "Delivery" && stall.isDeliveryPartnerEnabled) {
    getServiceability();
  }
  };

  useEffect(() => {
  // Fetch serviceability when address and stall are available
  if (address.id > 0 && stall.id > 0 && currentContext.deliveryMode === "Delivery" && stall.isDeliveryPartnerEnabled) {
    getServiceability();
  }
}, [address, stall, currentContext.deliveryMode]);

  const getStallById = () => {
    let apiOptions: any = {
      url: `stall/${stallId}`
    };
    http.get(apiOptions).then(res => {
      getStallCallBack(res.data);
    })
  };

  const getStallCallBack = (res) => {
    setStall(res);
    let deliveryModes: any = [];
    if (res.isDeliveryEnabled == 1 && res.isPickupEnabled == 0) {
      for (let item of allDeliveryModes) {
        if (item.value == "Delivery") {
          item.checked = true;
          deliveryModes.push(item);
        }
      }
    }
    else if (res.isDeliveryEnabled == 0 && res.isPickupEnabled == 1) {
      for (let item of allDeliveryModes) {
        if (item.value == "Pickup") {
          item.checked = true;
          deliveryModes.push(item);
        }
      }
      const data = { deliveryMode: "Pickup" };
      setCurrentContext(prevState => {
        return { ...prevState, ...data }
      });
    }
    else {
      deliveryModes = allDeliveryModes;
    }

    setDeliveryModes(deliveryModes);
    getPaymentOptions();
  };

  const getPaymentOptions = () => {
    let apiOptions: any = {
      url: `paymentoption/active/stall/${stallId}`
    };
    http.get(apiOptions).then(res => {
      getPaymentsCallBack(res);
    })
  };

  const getPaymentsCallBack = (res) => {
    let paymentOptionList = res.data;
    let paymentModes: any = [];
    for (let item of paymentOptionList) {
      let lookupItem = _.find(allPaymentOptions, { value: item.paymentOptionCode });
      if (lookupItem) {
        paymentModes.push(lookupItem);
      }
    }
    if (paymentModes.length == 1 && paymentModes[0].value == "cod") {
      paymentModes[0].checked = true;
      const data = { paymentMode: paymentModes[0].value };
      setCurrentContext(prevState => {
        return { ...prevState, ...data }
      });
    }
    setPaymentOptions(paymentModes);
  };

  const onDeliveryModeChange = (selected) => {
    updateCartActivity();
    const data = { deliveryMode: selected.value, deliverySlotId: 0, addressId: address.id };
    setCurrentContext(prevState => {
      return { ...prevState, ...data }
    });
    let tmpDelModes: any = deliveryModes.map((item: any) => {
      if (item.value === selected.value) {
        item.checked = true;
      }
      else {
        item.checked = false;
      }
      return item;
    });
    setDeliveryModes(tmpDelModes);
  //  console.log("Selected Delivery Mode:", selected.value);
  };

const onDeliveryPartnerChange = (selected) => {
  // If Porter was selected but is no longer available, default to self_delivery
  if (selected.value === "porter" && !stall?.uengageId) {
    selected.value = "self_delivery";
  }

  const data = { 
    deliveryPartner: selected.value,
    deliverySlotId: selected.value !== "self_delivery" ? 0 : currentContext.deliverySlotId
  };

  setCurrentContext(prev => ({
    ...prev,
    ...data
  }));

  let tmpPartners = deliveryPartners.map(p => ({
    ...p,
    checked: p.value === selected.value
  }));

  setDeliveryPartners(tmpPartners);

if (selected.value !== "self_delivery" && stall.isDeliveryPartnerEnabled) {
    getServiceability();
  }
};

const getServiceability = async() => {

  if(stall?.uengageId === null || stall?.uengageId === undefined){
    console.log("uengageId is not available. Skipping serviceability check.");
    return;
  }

    if (!address.fullAddress || !stall.address) {
    console.log("Waiting for address data...");
    return;
  }
  
  // console.log("Checking serviceability for address:", address.fullAddress);
   //console.log("Using stall address:", stall.address);

  const dropDetails = await geocodeAddress(address.fullAddress);
if (dropDetails) {
  console.log("Latitude:", dropDetails.lat);
  console.log("Longitude:", dropDetails.lng);
}

  const pickupDetails = await geocodeAddress(stall.address);
if (pickupDetails) {
  console.log("Latitude:", pickupDetails.lat);
  console.log("Longitude:", pickupDetails.lng);
}

  // Prepare the request data
  const requestData = {
    store_id:stall?.uengageId, // Convert to string as per API requirement
    pickupDetails: {
      latitude:pickupDetails?.lat.toString(), // Stall latitude (you might want to get this from stall data)
      longitude: pickupDetails?.lng.toString() // Stall longitude
    },
    dropDetails: {
      latitude:  dropDetails?.lat.toString(), // Use address latitude if available
      longitude:  dropDetails?.lng.toString() // Use address longitude if available
    }
  };
  setServiceabilityRequest(requestData); // Reset serviceability before new check

  let apiOptions: any = {
    url: `/order/check-serviceability`,
    method: 'POST', // This should be POST based on your curl
    data: requestData
  };
  
  http.post(apiOptions).then(res => {
    getServiceabilityCallBack(res);
  }).catch(error => {
    console.error("Serviceability check failed:", error);
    AlertService.showErrorMsg("Serviceability check failed. Please try again.");
  });
};

const getServiceabilityCallBack = (res) => {
  if (res.status === 200) {
    const serviceabilityData = res.data;
    
 //   Store the serviceability data in state or context
    setCurrentContext(prevState => {
      return { 
        ...prevState, 
        serviceability: serviceabilityData.serviceability,
        payouts: serviceabilityData.payouts
      }
    });
    
    console.log("Serviceability Data:", serviceabilityData);
    
    // You can use this data to show/hide delivery options or update UI
    if (!serviceabilityData.serviceability.locationServiceAble) {
      AlertService.showErrorMsg("Delivery not available to this location");
    }
    
    if (!serviceabilityData.serviceability.riderServiceAble) {
      AlertService.showMsg("No riders available at the moment");
    }
  }
};


  const onPaymentModeChange = (selected) => {
    const data = { paymentMode: selected.value };
    setCurrentContext(prevState => {
      return { ...prevState, ...data }
    });
    let tmpPayModes: any = paymentOptions.map((item: any) => {
      if (item.value === selected.value) {
        item.checked = true;
      }
      else {
        item.checked = false;
      }
      return item;
    });
    setPaymentOptions(tmpPayModes);
  };

  const getDefaultAddress = () => {
    let apiOptions: any = {
      url: `address/default/query`,
    };
    http.post(apiOptions).then(res => {
      getDefaultAddressCallBack(res);
    })
  };

  const getDefaultAddressCallBack = (res) => {
    const result = res.data;
    setAddress(result);
    let addObj = { addressId: 0 };
    if (result.id > 0) {
      addObj.addressId = result.id;
    }
    setCurrentContext(prevState => {
      return { ...prevState, ...addObj }
    });
    // if (result.id > 0 && result.locationId) {
    //   getDeliveryCharge(result.locationId)
    // }
  };

  const getAddressById = () => {
    let apiOptions: any = {
      url: `address/${currentContext.addressId}`,
    };
    http.get(apiOptions).then(res => {
      setAddress(res.data);
    })
  };

  // const getDeliveryCharge = (locationId) => {
  //   let inputData = {
  //     locationId: locationId,
  //     stallId: stallId
  //   }
  //   let apiOptions: any = {
  //     url: `stalldeliverylocation/deliverycharge`,
  //     data: inputData
  //   };
  //   http.post(apiOptions).then(res => {
  //     getDeliveryChargeCallBack(res);
  //   })
  // };

  // const getDeliveryChargeCallBack = (res) => {
  //   const result = res.data;
  //   let resultData = {
  //     deliveryCharge: result.deliveryCharge,
  //     minimumOrderAmount: result.minimumOrderAmount
  //   }
  //   setCurrentContext(prevState => {
  //     return { ...prevState, ...resultData };
  //   });
  // };

  const getAvailableSlots = () => {
    let inputData = {
      stallId: stallId
    };
    let apiOptions: any = {
      url: `stalldeliveryslot/available`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      getAvailableSlotsCallBack(res);
    })
  };

  const getAvailableSlotsCallBack = (res) => {
    const result = res.data;
    if (result.deliverySlots.length > 0) {
      let filterDelSlots = filterCurrentDaySlots(result.deliverySlots);
      for (let item of filterDelSlots) {
        item.startTime = item.startTime != null ? general.getFormattedTime(item.startTime) : null;
        item.endTime = item.endTime != null ? general.getFormattedTime(item.endTime) : null;
      }
      setAvailableSlots(filterDelSlots);
    }
    else {
      setAvailableSlots([]);
    }
    setCurrentContext(prevState => {
      return { ...prevState, ...{ deliverySlotId: 0 } }
    });
  };

  const filterCurrentDaySlots = (slotList) => {
    let currentDate = formatService.getCurrentDateForServer();
    let currentTime = formatService.getCurrentTimeForServer();
    let selDelDate = formatService.getDateStringForServer(currentContext.selectedDeliveryDate);
    if (currentDate == selDelDate) {
      slotList = slotList.filter(i => i.startTime > currentTime);
    }
    return slotList;
  }

  const onSelectSlot = (item) => {
     updateCartActivity();
    let deliverySlotId = 0;
    if (currentContext.deliverySlotId != item.id) {
      deliverySlotId = item.id;
    }
    setCurrentContext(prevState => {
      return { ...prevState, ...{ deliverySlotId: deliverySlotId } }
    });
  };

  const getAvailableCoupons = () => {
    let inputData = {
      entityTypeId: 3, // 3-Stall
      entityId: stallId
    };
    let apiOptions: any = {
      url: `coupon/list`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      getAvailableCouponsCallBack(res);
    })
  };

  const getAvailableCouponsCallBack = (res) => {
    if (res.data.length > 0) {
      let firstCoupon = res.data[0];
      let couponObj: any = {
        selectedUserCouponId: firstCoupon.userCouponId,
        selectedCouponValue: firstCoupon.couponValue,
        selectedCouponId: firstCoupon.couponId,
        selectedCouponValueTypeId: firstCoupon.couponValueTypeId
      };
      setCurrentContext(prevState => {
        return { ...prevState, ...couponObj }
      });
    }
    setCouponList(res.data);
  };

  const selectedCoupon = (item) => {
    let couponObj: any = {};
    if (currentContext.selectedUserCouponId == item.id || currentContext.selectedCouponId == item.id) {
      couponObj.selectedUserCouponId = 0;
      couponObj.selectedCouponValue = 0;
      couponObj.selectedCouponId = 0;
      couponObj.selectedCouponValueTypeId = 2;
    }
    else {
      couponObj.selectedUserCouponId = item.userCouponId;
      couponObj.selectedCouponValue = item.couponValue;
      couponObj.selectedCouponId = item.couponId;
      couponObj.selectedCouponValueTypeId = item.couponValueTypeId;
    }
    setCurrentContext(prevState => {
      return { ...prevState, ...couponObj }
    });

     setTimeout(() => syncCartToDB(), 100);
  };

  const getAvailableStallTiming = () => {
    let inputData = {
      stallId: stallId,
      communityId: communityId,
      currentDay: formatService.getDayByDate(formatService.getCurrentDateForServer())
    }
    let apiOptions: any = {
      url: `stalltiming/available`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      getAvailableStallTimingCallBack(res);
    })
  };

const getAvailableStallTimingCallBack = (res) => {
  const result = res.data;
  let currentAvailableTimings = result.currentAvailableTimings;
  let nextAvailableTimings = result.nextAvailableTimings;
  
  const currentMinDate = new Date(minDate);
  const today = new Date();
  
  // Only use today if it's >= minDate
  if (currentAvailableTimings && currentAvailableTimings.length > 0 && today >= currentMinDate) {
    setCurrentContext(prevState => {
      return { ...prevState, ...{ selectedDeliveryDate: formatService.getCurrentDateForServer() } }
    });
  }
  else if (nextAvailableTimings && nextAvailableTimings.length > 0) {
    let hours = 24;
    for (var i = 0; i < 6; i++) {
      let nextDate = formatService.getDateByAddedHrs(hours);
      let nextDay = formatService.getDayByDate(nextDate);
      let lookupItem = _.find(nextAvailableTimings, { day: nextDay.toLowerCase() });
      
      // Check if the found date is >= minDate
      const proposedDate = new Date(nextDate);
      if (lookupItem && proposedDate >= currentMinDate) {
        setCurrentContext(prevState => {
          return { ...prevState, ...{ selectedDeliveryDate: nextDate } }
        });
        break;
      }
      else {
        hours = hours + 24;
      }
    }
  }
};


  const confirmOrder = () => {
    if (currentContext.deliveryMode === "Delivery") {
      if (currentContext.addressId == 0) {
        AlertService.showErrorMsg("Please add or select address for Door delivery");
        return;
      }

       if (currentContext.deliveryPartner === "self_delivery") {
        if (currentContext.deliverySlotId === 0) {
          AlertService.showErrorMsg("Please select delivery slot");
          return;
        }
      }

     if (currentContext.deliveryPartner === "self_delivery") {
      if (availableSlots.length > 0 && !currentContext.deliverySlotId) {
        AlertService.showErrorMsg("Please select delivery slot");
        return;
      }
    }

    }
    else if (currentContext.deliveryMode === 'Pickup') {
      setCurrentContext(prevState => {
        return { ...prevState, ...{ addressId: 0 } }
      });
    }

    if (cart.items.length === 0) {
      AlertService.showErrorMsg("Please select products to order");
      return;
    }
    if (cart.totalAmount === 0) {
      AlertService.showErrorMsg("Order total should not be zero");
      return;
    }

    if ((!currentContext.selectedUserCouponId || !currentContext.selectedCouponId) && !currentContext.paymentMode) {
      AlertService.showErrorMsg("Please select any payment mode");
      return;
    }

    if ((currentContext.selectedUserCouponId > 0 || currentContext.selectedCouponId > 0) &&
      currentContext.selectedCouponValue < cart.totalAmount) {
      if (!currentContext.paymentMode) {
        AlertService.showErrorMsg("Please select payment mode for remaining payment");
        return;
      }
    }
    previewOrder();
  };

  const previewOrder = () => {
    const inputData = getOrderInputData();
    console.log("preview order currentContext.deliveryCharge", currentContext.deliveryCharge);
    let apiOptions: any = {
      url: `order/validate`,
      data: inputData
    };
    console.log("preview order inputData", inputData);
    http.post(apiOptions).then(res => {
      preViewOrderCallback(res);
    });
  }

  const preViewOrderCallback = (res) => {
    console.log("preview order response", res);
    setPreviewOrderData(res.data);
    setOpenPreviewDialog(true);
  };

  const closePreviewDialog = () => {
    setOpenPreviewDialog(false);
  }

  const prepareDataAndPlaceOrder = () => {
    setButtonDisable(true);
    const inputData = getOrderInputData();
    placeOrder(inputData);
    closePreviewDialog();
  };

const getOrderInputData = () => {
  const orderLines: any = [];
  let modifierAmt = 0;
  let orderTypeId = 0;
  
  if (currentContext.deliveryMode == 'Delivery') {
    orderTypeId = 1;
  }
  else if (currentContext.deliveryMode == 'Pickup') {
    orderTypeId = 2;
  }

  // Calculate delivery charge based on delivery partner
  const deliveryCharge = currentContext.deliveryPartner !== "self_delivery" 
    ? currentContext?.payouts?.total || currentContext.deliveryCharge
    : currentContext.deliveryCharge;

  for (let item of cart.items) {
    modifierAmt = 0;
    if (item.customizedDetails && item.customizedDetails.length > 0) {
      let totalModifierAmt = _.sumBy(item.customizedDetails, 'stallItemCustomizeDetailPrice');
      modifierAmt = item.quantity * totalModifierAmt;
    }
    if (item.quantity > 0) {
      let newItem = {
        ItemId: item.itemId,
        ItemName: item.itemName,
        Price: item.price,
        ItemQuantity: item.quantity,
        LineTotalPrice: (item.quantity * item.price) + modifierAmt,
        StallItemBatchId: item.id,
        StallItemId: item.stallItemId,
        LineModifierAmount: modifierAmt,
        OrderLineModifiers: item.customizedDetails ? item.customizedDetails : []
      };
      orderLines.push(newItem);
    }
  }

  const order = {
    
    id: 0,
    stallId: stallId,
    orderAmount: cart.totalAmount,
    orderTypeId: orderTypeId,
    paymentMode: currentContext.paymentMode,
    addressId: currentContext.addressId,
    userCouponId: currentContext.selectedUserCouponId,
    deliverySlotId: currentContext.deliverySlotId,
    orderDate: currentContext.selectedDeliveryDate,
    deliveryCharge: deliveryCharge, // Use the calculated delivery charge
    selectedDay: formatService.getDayByDate(currentContext.selectedDeliveryDate),
    communityId: communityId,
    uengageId: currentContext.deliveryPartner !== "self_delivery" ? stall?.uengageId : null,

    pickupDetailsName: stall?.name || "Store",
    pickupDetailsContactNumber: stall?.providerMobile,
    pickupDetailslatitude: serviceabilityRequest?.pickupDetails?.latitude, // You can get these from your existing geocode function
    pickupDetailslongitude: serviceabilityRequest?.pickupDetails?.longitude,
    pickupDetailsaddress: stall.address,
    pickupDetailscity: "Coimbatore",

    dropDetailsName: address.fullName,
    dropDetailsContactNumber: address.mobile,
    dropDetailslatitude: serviceabilityRequest?.dropDetails?.latitude, // You can get these from your existing geocode function
    dropDetailslongitude: serviceabilityRequest?.dropDetails?.latitude,
    dropDetailsaddress: address.fullAddress,
    dropDetailscity: "Coimbatore"
  };
  console.log("order data", order);
  let inputData = {
    Order: order,
    OrderLines: orderLines,
    CouponId: currentContext.selectedCouponId
  };
  
  return inputData;
};

  const placeOrder = (inputData) => {

  //  if(currentContext.deliveryPartner !== "self_delivery"){
    
  //  }

    let apiOptions: any = {
      url: `order/place`,
      data: inputData
    };
    console.log("place order inputData", inputData);
    http.post(apiOptions).then(res => {
      createOrderCallBack(res);
      console.log("place order response", res);
      //Delivery task creation moved to backend

      // if(inputData?.order?.orderTypeId != 2 && currentContext.deliveryPartner !== "self_delivery"){
      //   createDeliveryTask(res.data.orderId, res.data);
      // }

    //Delivery task creation moved to backend

    })
  };

  const createOrderCallBack = (res) => {
    if (res.status === 200) {
      const cartId = localstorage.getItem('activeCartId');
        if (cartId) {
            let apiOptions: any = { url: `cart/${cartId}` };
            http.delete(apiOptions).then(() => {
                localstorage.removeItem('activeCartId');
            });
        }
      navToOrderSummary(res.data.orderId);
    }
  };

  const navToOrderSummary = (orderId) => {
    let navData = {
      targetRoute: '/ordersummary/' + orderId,
      targetTitle: "Order Summary",
      targetData: {},
      sourceState: {},
      eventSource: '',
    };
    navigate(navData);
  }

        //Delivery task creation moved to backend

//   const createDeliveryTask = (orderId, orderResponse) => {
//   // Prepare the request data for Porter API
//   const porterRequestData = {
//     storeId: "89",
//     order_details: {
//       order_total: Math.round(cart.totalAmount * 100) / 100,
//       paid: currentContext.paymentMode === "cod" ? "false" : "true",
//       vendor_order_id: orderId.toString(),
//       order_source: "web",
//       customer_orderId: orderId.toString()
//     },
//     pickup_details: {
//       name: stall?.name || "Store",
//       contact_number: stall?.providerMobile,
//       latitude: serviceabilityRequest?.pickupDetails?.latitude, // You can get these from your existing geocode function
//       longitude: serviceabilityRequest?.pickupDetails?.longitude,
//       address: stall.address,
//       city: "Coimbatore"
//     },
//     drop_details: {
//       name: address.fullName,
//       contact_number: address.mobile,
//       latitude: serviceabilityRequest?.dropDetails?.latitude, // You can get these from your existing geocode function
//       longitude: serviceabilityRequest?.dropDetails?.latitude,
//       address: address.fullAddress,
//       city: "Coimbatore"
//     },
//     order_items: cart.items.map(item => ({
//       id: item.itemId?.toString() || item.id?.toString(),
//       name: item.itemName || 'Product',
//       quantity: item.quantity,
//       price: Math.round(item.price * 100) / 100
//     })),
//     // authentication: {
//     //   delivery_otp: "1234",
//     //   rto_otp: "1234"
//     // },
//     orderId: orderId
//   };

//   console.log("Creating Porter task with data:", porterRequestData);

//   let apiOptions: any = {
//     url: `/order/createTask`,
//     method: 'POST',
//     data: porterRequestData
//   };
  
//   http.post(apiOptions).then(res => {
//     createDeliveryTaskCallBack(res, orderId);
//   }).catch(error => {
//     console.error("Porter task creation failed:", error);
//     // Don't show error to user as order is already placed
//   });
// };

// const createDeliveryTaskCallBack = (res, orderId) => {
//   console.log("Porter task created successfully:", res.data);
  
//   if (res.data && res.data.success) {
//     console.log(`Porter delivery task created successfully for order ${orderId}`);
//   } else {
//     console.warn("Porter task creation response indicates failure:", res.data);
//   }
// };

      //Delivery task creation moved to backend

  const openAddressDialog = () => {
    setOpen(true);
  };

  const closeAddressDialog = () => {
    setOpen(false);
  };

  const onSelectAddress = (item) => {
    setCurrentContext(prevState => {
      return { ...prevState, ...{ addressId: item.id } };
    });
    setAddress(item);
    // if (item.locationId) {
    //   getDeliveryCharge(item.locationId)
    // }
    closeAddressDialog();
      if (currentContext.deliveryPartner !== "self_delivery" && stall.isDeliveryPartnerEnabled == true) {
    getServiceability();
  }

  };

  const onDeliveryDateSelect = (item) => {
    setCurrentContext(prevState => {
      return { ...prevState, ...{ selectedDeliveryDate: item.value } }
    });
  };

  const openAddressForm = () => {
    setAddOpen(true);
  };

  const closeAddressForm = () => {
    setAddOpen(false);
  };

  const onSaveCallback = () => {
    setAddOpen(false);
    getDefaultAddress();
  }

  useEffect(() => {
    onInit();
  }, []);

  useEffect(() => {
  }, [cartInfo]);

  useEffect(() => {
    getAvailableSlots();
  }, [currentContext.selectedDeliveryDate]);


  const geocodeAddress = async (address = "Plsm ladies hostel") => {
  try {
    const apiKey = 'AIzaSyB5xTZQjx5Ef_RsR5DIJtL5sstFKcFxY8M';
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`
    );
    
    const data = await response.json();
    
    if (data.status === 'OK' && data.results.length > 0) {
      const location = data.results[0].geometry.location;
     // console.log("Geocoded location:", location);
      return {
        lat: location.lat,
        lng: location.lng,
        formattedAddress: data.results[0].formatted_address
      };
    } else {
      throw new Error('Geocoding failed: ' + data.status);
    }
  } catch (error) {
    console.error('Geocoding error:', error);
    return null;
  }
};

useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;  // skip the initial run, flip the flag
    return;
  }
  syncCartToDB();
}, [cart.items, cart.totalAmount]);

// Update when cart changes
useEffect(() => {
  geocodeAddress();
  const newDateRange = calculateDeliveryDateRange(cart.items || []);
  setMinDate(newDateRange.minDate);
  setMaxDate(newDateRange.maxDate);
  
  // Immediately update selected date to the new minDate if current date is invalid
  const currentSelectedDate = new Date(currentContext.selectedDeliveryDate);
  const newMinDate = new Date(newDateRange.minDate);
  
  if (currentSelectedDate < newMinDate) {
    setCurrentContext(prevState => {
      return { ...prevState, ...{ selectedDeliveryDate: formatService.getDateStringForServer(newDateRange.minDate) } }
    });
  }
}, [cart.items]);

// Auto-select first available slot when date changes
// This works for both Delivery and Pickup
useEffect(() => {
  if (availableSlots.length > 0) {
    if (currentContext.deliverySlotId === 0) {
      const firstSlot = availableSlots[0];
      setCurrentContext(prevState => {
        return { ...prevState, ...{ deliverySlotId: firstSlot.id } }
      });
    }
    else {
      const selectedSlotExists = availableSlots.some(slot => slot.id === currentContext.deliverySlotId);
      if (!selectedSlotExists) {
        const firstSlot = availableSlots[0];
        setCurrentContext(prevState => {
          return { ...prevState, ...{ deliverySlotId: firstSlot.id } }
        });
      }
    }
  } else {
    setCurrentContext(prevState => {
      return { ...prevState, ...{ deliverySlotId: 0 } }
    });
  }
}, [availableSlots, currentContext.selectedDeliveryDate]);

//console.log("minDate, maxDate", minDate, maxDate);
  return (
    
    <div className="orderconfirmation-ui pt-5">

      <div className="content-container">

        {/* Desktop View */}
        <div className='deskview'>
          <div className="row col-12 p-4">
            <div className="row col-12 pb-4 pt-3">
              <h5>Order Confirmation</h5>
            </div>
            <div className='col-7'>
              <div className='row'>
                <div className='col-6 deliveryborder'>
                  <DeliveryMode
                    deliveryPartners={deliveryPartners}
                    deliveryModes={deliveryModes}
                    deliveryMode={currentContext.deliveryMode}
                    onDeliveryModeChange={onDeliveryModeChange}
                    onDeliveryPartnerChange={onDeliveryPartnerChange}
                    serviceability={currentContext.serviceability}
                    payouts={currentContext.payouts}

                  />
                </div>
                <div className='col-6 paymentborder pb-4'>
                  <PaymentMethod
                    paymentOptions={paymentOptions}
                    paymentMode={currentContext.paymentMode}
                    onPaymentModeChange={onPaymentModeChange}
                  />
                  <div>
                    <Coupons
                      couponList={couponList}
                      selectedCoupon={selectedCoupon}
                      selectedUserCouponId={currentContext.selectedUserCouponId}
                      selectedCouponId={currentContext.selectedCouponId}
                      stallId={stallId}
                    />
                  </div>
                </div>
              </div>
              <div className='row pb-5'>

                <div className='col-6  deliveryaddressborder'>
                {
  currentContext.deliveryMode == 'Delivery' && currentContext.deliveryPartner === "self_delivery" && 
  <DeliverySlots
    selectedDeliveryDate={currentContext.selectedDeliveryDate}
    onDeliveryDateSelect={onDeliveryDateSelect}
    availableSlots={availableSlots}
    onSelectSlot={onSelectSlot}
    deliverySlotId={currentContext.deliverySlotId}
    isSave={false}
    minDate={minDate} // Pass calculated min date
    maxDate={maxDate} // Pass calculated max date
  />
}
             {
  currentContext.deliveryMode == 'Pickup' &&
  <PickUpSlots
    selectedDeliveryDate={currentContext.selectedDeliveryDate}
    onDeliveryDateSelect={onDeliveryDateSelect}
    availableSlots={availableSlots}
    onSelectSlot={onSelectSlot}
    deliverySlotId={currentContext.deliverySlotId}
    isSave={false}
    minDate={minDate} // Use calculated minDate
    maxDate={maxDate} // Use calculated maxDate
  />
}
                </div>

                <div className='col-6'>
                  {
                    currentContext.deliveryMode === "Pickup" &&
                    <div className="pt-4">
                      <PickupAddress
                        stall={stall}
                        pickupDeliveryMsg={currentContext.pickupDeliveryMsg}
                      />
                    </div>
                  }
                  {
                    currentContext.deliveryMode === "Delivery" &&
                    <div className="pt-4">
                      <DeliveryAddress
                        openAddressDialog={openAddressDialog}
                        address={address}
                        openAddressForm={openAddressForm}
                      />
                      <div className="ml-1 mt-2 row">
                        <DeliveryCharge
                          deliveryCharge={currentContext.deliveryCharge}
                          deliveryChargeMsg={currentContext.deliveryChargeMsg}
                          doorDeliveryMsg={currentContext.doorDeliveryMsg}
                          minimumOrderAmount={currentContext.minimumOrderAmount}
                        />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div className='col-5'>
              <ReviewCart 
                userId={userId} 
                stallId={stallId} 
                confirmOrder={confirmOrder} 
                stallName={stall.name} 
                stallSlug={stall.slug}
                selectedCouponValue={
                    currentContext.selectedCouponId > 0 || currentContext.selectedUserCouponId > 0
                        ? currentContext.selectedCouponValueTypeId === 1
                            // Percent coupon → calculate amount
                            ? Math.round((cart.totalAmount * currentContext.selectedCouponValue) / 100)
                            // Flat value coupon → use directly  
                            : currentContext.selectedCouponValue
                        : 0
                }
            />
            </div>
          </div>
        </div>


        {/* Tablet View */}
        <div className='tabview'>
          <div className="row col-12 p-4">
            <div className="row col-12 pb-4 pt-3">
              <h5>Order Confirmation</h5>
            </div>
            <div className='col-12 pl-4'>
              <div className='row'>
                <div className='col-6 deliveryborder'>
                  <DeliveryMode
                  deliveryPartners={deliveryPartners}
                    deliveryModes={deliveryModes}
                    deliveryMode={currentContext.deliveryMode}
                    onDeliveryModeChange={onDeliveryModeChange}
                    onDeliveryPartnerChange={onDeliveryPartnerChange}
                    serviceability={currentContext.serviceability}  // Add this
                    payouts={currentContext.payouts}  
                  />
                </div>
                <div className='col-6 paymentborder pb-4'>
                  <PaymentMethod
                    paymentOptions={paymentOptions}
                    paymentMode={currentContext.paymentMode}
                    onPaymentModeChange={onPaymentModeChange}
                  />
                  <div>
                    <Coupons
                      couponList={couponList}
                      selectedCoupon={selectedCoupon}
                      selectedUserCouponId={currentContext.selectedUserCouponId}
                      selectedCouponId={currentContext.selectedCouponId}
                      stallId={stallId} 
                    />
                  </div>
                </div>
              </div>
              <div className='row pb-5'>
                {currentContext.deliveryPartner === "self_delivery" &&
                <div className='col-6  deliveryaddressborder'>
                  <DeliverySlots
                    selectedDeliveryDate={currentContext.selectedDeliveryDate}
                    onDeliveryDateSelect={onDeliveryDateSelect}
                    availableSlots={availableSlots}
                    onSelectSlot={onSelectSlot}
                    deliverySlotId={currentContext.deliverySlotId}
                    isSave={false}
                    minDate={currentContext.minDate}
                  />
                </div>}

                <div className='col-6'>
                  {
                    currentContext.deliveryMode === "Pickup" &&
                    <div className="pt-4">
                      <PickupAddress
                        stall={stall}
                        pickupDeliveryMsg={currentContext.pickupDeliveryMsg}
                      />
                    </div>
                  }
                  {
                    currentContext.deliveryMode === "Delivery" &&
                    <div className="pt-4">
                      <DeliveryAddress
                        openAddressDialog={openAddressDialog}
                        address={address}
                        openAddressForm={openAddressForm}
                      />
                      <div className="ml-1 mt-2 row">
                        <DeliveryCharge
                          deliveryCharge={currentContext.deliveryCharge}
                          deliveryChargeMsg={currentContext.deliveryChargeMsg}
                          doorDeliveryMsg={currentContext.doorDeliveryMsg}
                          minimumOrderAmount={currentContext.minimumOrderAmount}
                        />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div className='col-12'>
              <ReviewCart 
                userId={userId} 
                stallId={stallId} 
                confirmOrder={confirmOrder} 
                stallName={stall.name} 
                stallSlug={stall.slug}
                selectedCouponValue={
                    currentContext.selectedCouponId > 0 || currentContext.selectedUserCouponId > 0
                        ? currentContext.selectedCouponValueTypeId === 1
                            // Percent coupon → calculate amount
                            ? Math.round((cart.totalAmount * currentContext.selectedCouponValue) / 100)
                            // Flat value coupon → use directly  
                            : currentContext.selectedCouponValue
                        : 0
                }
            />
            </div>
          </div>
        </div>


        {/* Mobile View */}
        <div className='mobileview'>
          <div className="p-3">
            <div className="row col-12 pb-4 pt-3">
              <h5>Order Confirmation</h5>
            </div>
            <div className='pb-4'>
              <DeliveryMode
                deliveryPartners={deliveryPartners}
                deliveryModes={deliveryModes}
                deliveryMode={currentContext.deliveryMode}
                onDeliveryModeChange={onDeliveryModeChange}
                onDeliveryPartnerChange={onDeliveryPartnerChange}
                serviceability={currentContext.serviceability}  // Add this
                payouts={currentContext.payouts}  
              />
            </div>
            <div>
              <PaymentMethod
                paymentOptions={paymentOptions}
                paymentMode={currentContext.paymentMode}
                onPaymentModeChange={onPaymentModeChange}
              />
              <div>
                <Coupons
                  couponList={couponList}
                  selectedCoupon={selectedCoupon}
                  selectedUserCouponId={currentContext.selectedUserCouponId}
                  selectedCouponId={currentContext.selectedCouponId}
                  stallId={stallId} 
                />
              </div>
            </div>

{currentContext.deliveryPartner === "self_delivery" &&
            <div className='pb-4'>
              <DeliverySlots
                selectedDeliveryDate={currentContext.selectedDeliveryDate}
                onDeliveryDateSelect={onDeliveryDateSelect}
                availableSlots={availableSlots}
                onSelectSlot={onSelectSlot}
                deliverySlotId={currentContext.deliverySlotId}
                isSave={false}
                minDate={currentContext.minDate}
              />
            </div>}

            <div>
              {
                currentContext.deliveryMode === "Pickup" &&
                <div className="pt-4">
                  <PickupAddress
                    stall={stall}
                    pickupDeliveryMsg={currentContext.pickupDeliveryMsg}
                  />
                </div>
              }
              {
                currentContext.deliveryMode === "Delivery" &&
                <div className="pt-4">
                  <DeliveryAddress
                    openAddressDialog={openAddressDialog}
                    address={address}
                    openAddressForm={openAddressForm}
                  />
                  <div className="ml-1 mt-2 row">
                    <DeliveryCharge
                      deliveryCharge={currentContext.deliveryCharge}
                      deliveryChargeMsg={currentContext.deliveryChargeMsg}
                      doorDeliveryMsg={currentContext.doorDeliveryMsg}
                      minimumOrderAmount={currentContext.minimumOrderAmount}
                    />
                  </div>
                </div>
              }
            </div>


            <div className='col-12 px-0 pt-3'>
              <ReviewCart 
                userId={userId} 
                stallId={stallId} 
                confirmOrder={confirmOrder} 
                stallName={stall.name} 
                stallSlug={stall.slug}
                selectedCouponValue={
                    currentContext.selectedCouponId > 0 || currentContext.selectedUserCouponId > 0
                        ? currentContext.selectedCouponValueTypeId === 1
                            // Percent coupon → calculate amount
                            ? Math.round((cart.totalAmount * currentContext.selectedCouponValue) / 100)
                            // Flat value coupon → use directly  
                            : currentContext.selectedCouponValue
                        : 0
                }
            />
            </div>
          </div>
        </div>


        <div>
          <Dialog
            open={open}
            maxWidth="md"
            fullWidth
            onClose={closeAddressDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <UserAddress userId={userId} onSelectAddress={onSelectAddress} closeAddressDialog={closeAddressDialog} />
          </Dialog>
          <Dialog
            open={addOpen}
            maxWidth="sm"
            onClose={closeAddressForm}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <AddressForm userId={userId} addressId={0} closeAddressForm={closeAddressForm}
              onSaveCallback={onSaveCallback} />
          </Dialog>
          <Dialog
            open={openPreviewDialog}
            maxWidth="sm"
            onClose={closePreviewDialog}>
            <PreviewOrder orderData={previewOrderData} closePreviewDialog={closePreviewDialog} placeOrder={prepareDataAndPlaceOrder} buttonDisable={buttonDisable} serviceabilityRequest={serviceabilityRequest} payouts={currentContext.payouts} />
          </Dialog>
        </div>
      </div>
    </div>
  )
};

export default OrderConfirmation;